export default __webpack_public_path__ + "static/media/illustration-upload.3d324628.svg";